import { BQuery } from '@bytel/query';
import getConfig from '@shared/misc/configuration';

/**
 * Classe de base pour les services API Bytel externes
 * Permet de configurer une baseURL différente de l'API YSER principale
 */
export default class BytelAPIServicesBase {
  constructor(protected bquery: BQuery) {}

  /**
   * Construit l'URL complète pour un endpoint Bytel
   * @param href - Le chemin de l'endpoint (relatif ou absolu)
   * @returns L'URL complète
   */
  async getUrl(href: string): Promise<URL> {
    if (href.startsWith('http')) {
      return new URL(href);
    }

    // Récupère la baseURL configurée pour l'API Bytel depuis la config
    const config = await getConfig();
    let baseUri = config.BYTEL_API_URL ?? this.bquery?.config?.baseURL ?? 'http://localhost:7001';

    if (baseUri.endsWith('/')) {
      baseUri = baseUri.substring(0, baseUri.length - 1);
    }

    return new URL(`${baseUri}${href}`);
  }
}
